import type {
  MarketplacePluginInstall,
  MarketplacePluginListing,
} from '@gitlab-org/duo-plugin-marketplace/node';
import { bold, dim } from '../../../utils/console_style';
import { describeScope, joinWithMore } from '../describe_scope';

function describeInstall(install: MarketplacePluginInstall): string {
  return `${describeScope(install.scope, install.projectPath)} (${install.version})`;
}

function formatPlugin(plugin: MarketplacePluginListing): string {
  const { name, version, description, installs } = plugin;
  const header = version ? `${bold(name)} ${dim(version)}` : bold(name);
  const lines = [header];
  if (description) {
    lines.push(description);
  }
  if (installs.length > 0) {
    const installsLine = joinWithMore(installs.map(describeInstall));
    lines.push(dim(`installed: ${installsLine}`));
  }
  return lines.join('\n');
}

export function formatMarketplaceShow(
  marketplaceName: string,
  plugins: MarketplacePluginListing[],
): string {
  if (plugins.length === 0) {
    return `No plugins in marketplace ${marketplaceName}.`;
  }

  return plugins.map((plugin) => `\n${formatPlugin(plugin)}`).join('\n');
}
